import { BackednResponse } from "@shared/lib/types";
import {
  IBriefInvoiceSearchRequest,
  IGetBriefInvoices,
} from "@shared/lib/types/briefInvoice";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INVOICE_QUERY_KEY } from "../constants";

export function useGetBriefInvoices(params: IBriefInvoiceSearchRequest) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBriefInvoices>
  >({
    queryKey: [...BRIEF_INVOICE_QUERY_KEY, params],
    queryFn: () => BriefService.getBriefInvoices(params),
    enabled: !!params.briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    invoices: data?.data?.data || [],
    totalCount: data?.data?.pagination.totalCount || 0,
    isFetching: isLoading,
    isError,
  };
}
